import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';
import SectionSelector from './SectionSelector';

export default class RsvpModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    this.status = this.attrs.status;
    this.section = app.session.user.attribute('defaultSection') || '';
    this.comment = '';
    this.loading = false;
  }

  className() {
    return 'RsvpModal Modal--small';
  }

  title() {
    return app.translator.trans('florcarioca-rsvp.forum.modal.title_attending');
  }

  content() {
    const sections = JSON.parse(app.forum.attribute('florCariocaSections') || '[]');

    return (
      <div className="Modal-body">
        <div className="Form">
          <div className="Form-group">
            <label>{app.translator.trans('florcarioca-rsvp.forum.modal.section_label')}</label>
            <SectionSelector
              value={this.section}
              onchange={(value) => {
                this.section = value;
              }}
              sections={sections}
            />
            <p className="helpText">
              {app.translator.trans('florcarioca-rsvp.forum.modal.section_help')}
            </p>
          </div>

          <div className="Form-group">
            <label>{app.translator.trans('florcarioca-rsvp.forum.modal.comment_label')}</label>
            <textarea
              className="FormControl"
              placeholder={app.translator.trans('florcarioca-rsvp.forum.modal.comment_placeholder')}
              value={this.comment}
              maxlength="200"
              rows="3"
              oninput={(e) => {
                this.comment = e.target.value;
              }}
            />
            <p className="helpText">
              {this.comment.length}/200 {app.translator.trans('florcarioca-rsvp.forum.modal.characters')}
            </p>
          </div>

          <div className="Form-group">
            <Button
              className="Button Button--primary Button--block"
              loading={this.loading}
              onclick={() => this.submit()}
            >
              {app.translator.trans('florcarioca-rsvp.forum.modal.submit')}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  async submit() {
    this.loading = true;
    m.redraw();

    try {
      await this.attrs.onsubmit(this.section, this.comment);
    } catch (e) {
      this.loading = false;
      m.redraw();
      throw e;
    }
  }
}
